import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_07_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-07-01",
    "name": "头枕地对抗",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["仰卧头轻压地面", "深层颈屈肌激活"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/eb62ad2e4e25cf6f67471999.mp4",
    "videoUrl": "/media/collections-20261008/videos/fcd71a7fefe0b55d1a259145.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第7期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-07-02",
    "name": "拉伸对抗",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["拉伸与对抗交替", "增加关节活动度"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/reviewed-66ce294f60dd53ce8a20a61b.mp4",
    "videoUrl": "/media/collections-20261008/videos/1e44ec36353218a0d895d730.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第7期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-07-03",
    "name": "泡沫轴支撑",
    "bodyPart": "warmup",
    "equipment": "foam-roller",
    "subCategory": "shoulder",
    "tips": ["按新视频将头部搭在泡沫轴上保持支撑", "此处为训练前静态支撑示范"],
    "sets": 2,
    "reps": "15次",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "demoUrl": "/media/collections-20261008/demos/reviewed-6447bf2bbe0a3dc6f2332256.mp4",
    "videoUrl": "/media/collections-20261008/videos/854ead11bf221b42687e27eb.mp4",
    "targetMuscles": ["颈部稳定肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第7期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-07-04",
    "name": "三角肌后束",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "rear-deltoid",
    "tips": ["俯卧位后束收缩", "顶峰保持1秒"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/58b30fb68a179a0faba5ef65.mp4",
    "videoUrl": "/media/collections-20261008/videos/0c4080d25461cee7148ddf8b.mp4",
    "targetMuscles": ["三角肌后束"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第7期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-07-05",
    "name": "外旋位推肩",
    "bodyPart": "shoulders",
    "equipment": "bodyweight",
    "subCategory": "shoulder",
    "tips": ["外旋位启动", "激活肩袖肌群"],
    "sets": 2,
    "reps": "15次",
    "rpe": 5,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-6cf7324574e83186972e64ca.mp4",
    "videoUrl": "/media/collections-20261008/videos/e22adaab2da0b378e9a56bf3.mp4",
    "targetMuscles": ["全身激活肌群"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第7期",
    "isStretch": false,
    "demoStatus": "ready",
  },
];
